import { CheckmarkIcon } from '@calizahq/react-components-v2'
import clsx from 'clsx'
import React from 'react'

interface BreadcrumbProps {
  index: number
  isActive?: boolean
  isComplete?: boolean
  label: string
  offsetFirstBreadcrumb?: boolean
}

export function Breadcrumb({ index, isActive, isComplete, label, offsetFirstBreadcrumb = false }: BreadcrumbProps) {
  const isFirst = index === 0
  return (
    <StyledButton isFirst={offsetFirstBreadcrumb ? isFirst : false}>
      {isComplete ? <CheckmarkIcon className="ml-3 w-5" /> : null}
      <p
        className={clsx(
          'whitespace-nowrap font-bold md:ml-4 md:text-p-md',
          isActive ? 'text-primary text-p-md' : 'text-tertiary text-p-sm',
          !isComplete && 'ml-3',
        )}
      >
        {label}
      </p>
    </StyledButton>
  )
}

interface StyledButtonProps {
  isFirst: boolean
}

const StyledButton = ({
  isFirst,
  className,
  ...props
}: StyledButtonProps & React.ComponentPropsWithoutRef<'button'>) => (
  <button
    {...props}
    className={clsx('flex items-center mt-2 px-0 md:mt-0 md:px-4', isFirst && 'pl-0 md:pl-0', className)}
  />
)
